-- A comptime type function can parse a literal and build a function signature.
-- This tiny DSL expands a binary string into exact integer digit types:
-- Binary("1101") becomes the pack (1, 1, 0, 1) while the file is checked.
const types = require("types")

@comptime
local function Binary(Source: string): typepack
    local digits = {}
    for index = 1, #Source do
        local digit = Source:sub(index, index)
        if digit == "0" then
            digits[#digits + 1] = types.literal(0)
        elseif digit == "1" then
            digits[#digits + 1] = types.literal(1)
        else
            return types.error("expected binary digits, got " .. Source)
        end
    end

    return types.pack(digits)
end

-- The first argument is a compile-time-known string. `unpackof` turns the
-- tuple computed from it into the rest of this call's parameter list, so the
-- checker requires the caller to supply exactly those integer digits.
local function decimal<const Source: string>(source: Source, ...: unpackof Binary(Source)): number
    local value = 0
    for index = 1, select("#", ...) do
        local digit = select(index, ...) as integer
        value = value * 2 + digit
    end

    return value
end

print(decimal("1101", 1, 1, 0, 1)) -- 13
print(decimal("101010", 1, 0, 1, 0, 1, 0)) -- 42

-- try breaking it: write a digit other than 0 or 1 in either the string or
-- its expanded integer arguments, and read the diagnostic at the call
